module.exports = __webpack_public_path__ + "img/t-shirt.d3e26a58.svg";